import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { MultiSelect } from "primereact/multiselect";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Modal from "../../../components/modal/Modal";
//services
import { getFacebookConnected } from "../../../services/Crm/Facebook/getFacebookConnected";
import { postFacebookCallback } from "../../../services/Crm/Facebook/postFacebookCallback";
//utils
import { queryClient } from "../../../utils/queryClient";

const ModalFacebook = ({ visible, onHide }) => {
  const [loadingButton, setLoadingButton] = useState(false);
  const [facebookToken, setFacebookToken] = useState(null);
  const [userFaceId, setUserFaceId] = useState(null);
  const [pages, setPages] = useState([]);
  const [selectedPages, setSelectedPages] = useState([]);
  const [loadingPages, setLoadingPages] = useState(false);
  const [hasSaved, setHasSaved] = useState(false);

  const { data, isLoading } = useQuery(
    "connectedFacebook",
    getFacebookConnected
  );

  const handleConnectFacebook = () => {
    const redirectUri = window.location.href;
    window.location.href =
      `https://www.facebook.com/dialog/oauth` +
      `?client_id=1461731588615625` +
      `&scope=pages_manage_metadata,leads_retrieval,pages_read_engagement,pages_show_list,ads_management` +
      `&response_type=token` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&state=facebook_login`;
  };

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const token = hash.get("access_token");
    const state = hash.get("state");
    if (token && state === "facebook_login") {
      setFacebookToken(token);
    }
  }, []);

  useEffect(() => {
    if (!facebookToken) return;

    fetch(
      `https://graph.facebook.com/me?fields=id&access_token=${facebookToken}`
    )
      .then((res) => res.json())
      .then((js) => setUserFaceId(js.id))
      .catch(() => toast.error("Não foi possível obter Facebook ID."));

    setLoadingPages(true);
    fetch(
      `https://graph.facebook.com/me/accounts?access_token=${facebookToken}`
    )
      .then((res) => res.json())
      .then((js) => setPages(js.data || []))
      .catch(() => toast.error("Erro ao listar páginas."))
      .finally(() => setLoadingPages(false));
  }, [facebookToken]);

  const handleSavePages = async () => {
    setLoadingButton(true);
    const notif = toast.loading("Salvando conexão e páginas...");
    try {
      const pagesPayload = pages
        .filter((p) => selectedPages.includes(p.id))
        .map((p) => p.id);

      await postFacebookCallback({
        access_token: facebookToken,
        user_face_id: userFaceId,
        page_ids: pagesPayload,
      });

      queryClient.setQueryData(["connectedFacebook"], () => ({
        facebook_connected: true,
      }));
      setHasSaved(true);
      toast.update(notif, {
        render: "Páginas salvas com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      window.history.replaceState(null, null, window.location.pathname);
      setFacebookToken(null);
      onHide();
    } catch {
      toast.update(notif, {
        render: "Erro ao salvar páginas.",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } finally {
      setLoadingButton(false);
    }
  };

  const handleClose = () => {
    if (facebookToken && !hasSaved) {
      confirmDialog({
        message: "Você ainda não salvou as páginas. Deseja cancelar o login?",
        header: "Cancelar Conexão Facebook",
        icon: "fa-solid fa-triangle-exclamation",
        acceptLabel: "Sim, cancelar",
        rejectLabel: "Não",
        accept: () => {
          window.history.replaceState(null, null, window.location.pathname);
          setFacebookToken(null);
          onHide();
        },
      });
    } else {
      window.history.replaceState(null, null, window.location.pathname);
      onHide();
    }
  };

  return (
    <Modal
      visible={visible}
      onHide={handleClose}
      dynamicTitle="Conexão com Facebook"
      closable
    >
      <div className="text-center px-4 py-3">
        {/* Header com gradiente */}
        <div 
          className="mb-4 p-4 rounded-4"
          style={{
            background: "linear-gradient(135deg, #1877F2 0%, #42A5F5 100%)",
            color: "white",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <div 
            className="icon-container mx-auto mb-3"
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(10px)",
              border: "2px solid rgba(255,255,255,0.3)"
            }}
          >
            <i
              className="fa-brands fa-facebook"
              style={{ fontSize: "2.5rem", color: "white" }}
            />
          </div>
          <h3 className="mb-2 fw-bold">Facebook Ads</h3>
          
          {!data?.facebook_connected && !facebookToken && (
            <p className="mb-0 opacity-90">
              Conecte sua conta para importar anúncios e páginas
            </p>
          )}
        </div>

        {(isLoading || (facebookToken && loadingPages)) && (
          <div className="my-4">
            <div className="d-flex justify-content-center mb-3">
              <div 
                className="spinner-border text-primary" 
                style={{ width: "3rem", height: "3rem" }}
                role="status"
              >
                <span className="visually-hidden">Carregando...</span>
              </div>
            </div>
            <p className="text-muted">Carregando informações...</p>
          </div>
        )}

        {!facebookToken && !isLoading && (
          <div className="my-4">
            <button
              className="btn btn-lg w-100 text-white fw-bold py-3"
              style={{
                background: "linear-gradient(135deg, #1877F2 0%, #42A5F5 100%)",
                border: "none",
                borderRadius: "15px",
                fontSize: "1.1rem",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(24, 119, 242, 0.3)"
              }}
              onClick={handleConnectFacebook}
              disabled={loadingButton}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 8px 25px rgba(24, 119, 242, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 15px rgba(24, 119, 242, 0.3)";
              }}
            >
              {loadingButton ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Conectando...
                </>
              ) : (
                <>
                  <i className="fa-brands fa-facebook me-2"></i>
                  Conectar com Facebook
                </>
              )}
            </button>
          </div>
        )}

        {facebookToken && !isLoading && !loadingPages && (
          <div className="my-4">
            {/* Status de conexão */}
            <div 
              className="alert alert-success border-0 rounded-4 mb-4"
              style={{
                background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                color: "white"
              }}
            >
              <i className="fa-solid fa-check-circle me-2"></i>
              Conectado como <strong>{userFaceId}</strong>
            </div>

            {/* Seleção de páginas */}
            <div className="mb-4">
              <label className="form-label fw-bold text-start d-block mb-3">
                <i className="fa-solid fa-page4 me-2 text-primary"></i>
                Selecione as páginas do Facebook:
              </label>
              
              <div className="position-relative">
                <MultiSelect
                  value={selectedPages}
                  options={pages}
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Escolha suas páginas..."
                  filter
                  className="w-100"
                  style={{
                    borderRadius: "12px",
                    border: "2px solid #e9ecef",
                    minHeight: "50px"
                  }}
                  onChange={(e) => setSelectedPages(e.value)}
                />
              </div>
              
              {selectedPages.length > 0 && (
                <div className="mt-3">
                  <small className="text-success">
                    <i className="fa-solid fa-check me-1"></i>
                    {selectedPages.length} página(s) selecionada(s)
                  </small>
                </div>
              )}
            </div>

            {/* Botões de ação */}
            <div className="d-flex gap-3 justify-content-center">
              <button
                className="btn btn-outline-danger btn-lg px-4 py-2"
                style={{
                  borderRadius: "12px",
                  borderWidth: "2px",
                  transition: "all 0.3s ease"
                }}
                onClick={handleClose}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#dc3545";
                  e.target.style.color = "white";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#dc3545";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                <i className="fa-solid fa-x me-2"></i>
                Cancelar
              </button>
              
              <button
                className="btn btn-lg px-4 py-2 text-white fw-bold"
                style={{
                  background: selectedPages.length > 0 
                    ? "linear-gradient(135deg, #28a745 0%, #20c997 100%)"
                    : "#6c757d",
                  border: "none",
                  borderRadius: "12px",
                  transition: "all 0.3s ease",
                  boxShadow: selectedPages.length > 0 
                    ? "0 4px 15px rgba(40, 167, 69, 0.3)"
                    : "none"
                }}
                onClick={handleSavePages}
                disabled={!selectedPages.length || loadingButton}
                onMouseEnter={(e) => {
                  if (selectedPages.length > 0) {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 8px 25px rgba(40, 167, 69, 0.4)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedPages.length > 0) {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.3)";
                  }
                }}
              >
                {loadingButton ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Salvando...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-floppy-disk me-2"></i>
                    Salvar Páginas
                  </>
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalFacebook;
